import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footerWrapper container">
        <div className="year">© 2023-2024</div>
        <div className="info">
          <span className="mr-4">CMGT</span>
          <span className="mr-4">Medialab 1</span>
          <span className="mr-4">Team 1</span>
          <span>Kenniscentrum Zorginnovatie</span>
        </div>
      </div>
    </footer>
  );
}
